import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const query = gql`
query AvgVoteByOperatorForRequestType($requestTypeId: Int!) {
  avgVoteByOperatorForRequestType(requestTypeId: $requestTypeId) {
    id,
    fullName,
    avgVote
  }
}`;

function getAvgVoteByOperatorForRequestType(requestTypeId) {
  return apollo.client.query({
    query,
    fetchPolicy: 'network-only',
    variables: {
      requestTypeId: parseInt(requestTypeId, 10),
    },
  }).then((data) => data.data.avgVoteByOperatorForRequestType);
}

export default getAvgVoteByOperatorForRequestType;
